import { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import {
  Button,
  Checkbox,
  Divider,
  Header,
  Icon,
  Progress,
} from "semantic-ui-react";
import moment from "moment";
import { pdfjs, Document, Page } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const UploadOrderForm = (props) => {
  const {
    formToUpload,
    setFormToUpload,
    uploading,
    selectedOrderForm,
    setSelectedOrderForm,
    uploadProgress,
    orderFormNumPages,
    orderFormPageNumber,
    selectedJob,

    setOrderFormNumPages,
    setOrderFormPageNumber,
    pdfPreviewUrl,
  } = props;

  const fileTypes = ["PDF"];

  const handleChangeLogo = async (file) => {
    const fileExt = file.name.split(".")[1];
    const newName = sanitizeS3Filename(file.name);
    const newFile = renameFile(file, `${newName}`);
    console.log(newFile);
    setSelectedOrderForm(fileExt.toLowerCase());
    setFormToUpload(newFile);
  };

  const renameFile = (file, newName) => {
    return new File([file], newName, {
      type: file.type,
      lastModified: file.lastModified,
    });
  };

  const sanitizeS3Filename = (filename) => {
    return filename
      .replace(/[^a-zA-Z0-9.\-_]/g, "_") // Replace unsafe characters with underscore
      .replace(/_{2,}/g, "_") // Replace multiple underscores with a single one
      .replace(/^_|_$/g, ""); // Remove leading or trailing underscores
  };

  const onDocumentLoadSuccess = (data) => {
    console.log(data.numPages);
    setOrderFormNumPages(data.numPages);
    setOrderFormPageNumber(1);
  };

  return (
    <div>
      <Header
        content="Upload PDF"
        subheader="A paper order form is required to be uploaded before an invoice can be generated."
      />
      <FileUploader
        handleChange={handleChangeLogo}
        name="file"
        types={fileTypes}
        hoverTitle=" "
        children={
          <div
            style={{
              cursor: "pointer",
              borderStyle: "dashed",
              flex: 1,
              height: "auto",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "20px",
              borderColor: "#888888",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "40px",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Header
                style={{ textAlign: "center", marginBottom: "10px" }}
                content="Drop a file here to upload"
                subheader="Required File Type: PDF"
              />
              <Button content="Browse" size="large" />
              {formToUpload !== null && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Divider />
                  <Header as="h2" icon style={{ textAlign: "center" }}>
                    <Icon
                      loading={uploading}
                      name={
                        uploading ? "circle notch" : "file alternate outline"
                      }
                    />
                    {uploading ? "Uploading..." : "Ready to Upload"}
                    <Header.Subheader>
                      {formToUpload.name ? formToUpload.name : null}
                    </Header.Subheader>
                  </Header>

                  {uploading && (
                    <Progress
                      style={{ width: "100%" }}
                      fluid
                      indicating={uploading}
                      percent={Math.ceil(uploadProgress * 100)}
                      progress={Math.ceil(uploadProgress * 100)}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        }
      />

      {pdfPreviewUrl && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            marginTop: "10px",
          }}
        >
          <Header content="File Preview" />
          <div>
            <Document
              file={pdfPreviewUrl}
              onLoadSuccess={onDocumentLoadSuccess}
            >
              <Page pageNumber={orderFormPageNumber} width={200} />
            </Document>
          </div>
        </div>
      )}
    </div>
  );
};
export default UploadOrderForm;
